import 'react-quill/dist/quill.snow.css'
import PolicyEditor from '../../../Utilities/PolicyEditor'

const PrivacyPolicy = () => {
  return <PolicyEditor title="Privacy Policy" fieldKey="privacyPolicy" />
}

export default PrivacyPolicy
